var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
export class ElasticsearchFieldModel {
    type;
    name;
    displayName;
    isAggregatable;
    // This is helping us workaround the fact that we don't really get an ID, and we return the value of fieldName
    // as the ID.
    get id() {
        return this.name;
    }
}
__decorate([
    Expose({ name: 'aggregatable' }),
    __metadata("design:type", Boolean)
], ElasticsearchFieldModel.prototype, "isAggregatable", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], ElasticsearchFieldModel.prototype, "id", null);
//# sourceMappingURL=elasticsearch-field.js.map